import React, { useMemo } from 'react';

import {
  Text, Input, HStack, useToast,
} from '@chakra-ui/react';
import DatePicker, { utils } from 'react-modern-calendar-datepicker';

import { locale } from 'constants/translations';
import colors from 'theme/colors';

export default function DateRange({ range, setRange }) {
  const toast = useToast();

  const renderCustomInput = ({ ref }) => {
    const handleDate = ({ day, month }) => (`${day}/${month}`);

    const value = useMemo(() => {
      if (range.from && range.to) {
        return `${handleDate(range.from)} a ${handleDate(range.to)}`;
      }
      return 'Selecione um período';
    }, [range]);

    return (
      <Input
        ref={ref}
        value={value}
      />
    );
  };

  return (
    <HStack
      alignItems="center"
      ml={8}>
      <Text>Período de</Text>
      <DatePicker
        value={range}
        onChange={setRange}
        colorPrimary={colors.primary.default}
        colorPrimaryLight={colors.primary.transparent}
        renderInput={renderCustomInput}
        inputPlaceholder="Selecione"
        shouldHighlightWeekends
        maximumDate={utils('en').getToday()}
        onDisabledDayError={() => toast({
          description: 'Não é possivel ver o futuro!',
          isClosable: true,
          title: 'Data inválida',
          status: 'error',
          duration: 5000,
          position: 'top-right',
        })}
        locale={locale}
      />
    </HStack>
  );
}
